import { EStatusStr } from '@src/emp-3.0/types/enum';
import { EMetricTypes } from '../types';
import { metricTypeMapping } from '../components/DeploymentDrawer/constants';

export const METRIC_LIST_QUERY_KEY = 'METRIC_LIST_QUERY_KEY';
export const METRIC_SUPPORTED_UNITS_QUERY_KEY = 'METRIC_SUPPORTED_UNITS_QUERY_KEY';
export const GET_MAPPED_EVENT_BY_ID = 'getMappedEventById';
export const DIMENSION_LIST = 'DIMENSION_LIST';
export const USER_DEFINED_CUSTOM_DIMENSION = 'USER_DEFINED_CUSTOM_DIMENSION';
export const USE_CUSTOM_DIMENSION_MANAGEMENT_LIST = 'USE_CUSTOM_DIMENSION_MANAGEMENT_LIST';
export const CUSTOM_DIMENSION_LIST = 'CUSTOM_DIMENSION_LIST';
export const GET_REMAIN_COUNT = 'GET_REMAIN_COUNT';
export const POST_ATTRIBUTE_TYPE_QUERY_KEY = 'POST_ATTRIBUTE_TYPE_QUERY_KEY';
export const GET_MAPPED_EVENT_NAMES = 'GET_MAPPED_EVENT_NAMES';
export const GET_RAW_CONFIG = 'GET_RAW_CONFIG';
export const GET_SHARE_SANKEY = 'GET_SHARE_SANKEY';
export const GET_SHARE_FUNNEL = 'GET_SHARE_FUNNEL';

export const GET_EXPLORER_IP_LIST = 'GET_EXPLORER_IP_LIST';
export const GET_EXPLORER_USERS_LIST = 'GET_EXPLORER_USERS_LIST';
export const GET_EXPLORER_EVENT_LIST = 'GET_EXPLORER_EVENT_LIST';
export const GET_USER_INFO_BY_USER_ID_OR_CLIENT_ID = 'GET_USER_INFO_BY_USER_ID_OR_CLIENT_ID';
export const GET_METRIC_MANAGEMENT_LIST = 'GET_METRIC_MANAGEMENT_LIST';
export const GET_FLOW_OUTPUTS = 'GET_FLOW_OUTPUTS';
export const GET_FLOW_LIST = 'GET_FLOW_LIST';
export const GET_FLOW_DETAILS_BY_ID = 'GET_FLOW_DETAILS_BY_ID';
export const GET_FLOW_MANAGEMENT_LIST = 'GET_FLOW_MANAGEMENT_LIST';
export const GET_FLOW_LABELS = 'flow-labels';
export const GET_JOURNEY_STAGES = 'journey-stages';
export const GET_METRIC_DETAIL_IN_MANAGEMENT = 'GET_METRIC_DETAIL_IN_MANAGEMENT';
export const GET_EVENT_LIST_FOR_METRIC = 'GET_EVENT_LIST_FOR_METRIC';
export const GET_EVENT_LIST_FOR_FLOW = 'GET_EVENT_LIST_FOR_FLOW';
export const GET_DATA_DICTIONARY = 'GET_DATA_DICTIONARY';

export const GET_SENSITIVE_CONFIG = 'GET_SENSITIVE_CONFIG';
export const GET_SENSITIVE_CONFIG_META = 'GET_SENSITIVE_CONFIG_META';

export const GET_CALCULABLE_METRICS = 'GET_CALCULABLE_METRICS';

export const statusOptions = [
  { label: EStatusStr.ALL, value: EStatusStr.ALL },
  { label: EStatusStr.Deployed, value: EStatusStr.Deployed },
  { label: EStatusStr.Undeployed, value: EStatusStr.Undeployed },
];

export const metricTypeOptions = [
  { label: EStatusStr.ALL, value: EStatusStr.ALL },
  { label: metricTypeMapping[EMetricTypes.DURATION], value: EMetricTypes.DURATION },
  { label: metricTypeMapping[EMetricTypes.CONVERSION], value: EMetricTypes.CONVERSION },
  { label: metricTypeMapping[EMetricTypes.SINGLE_EVENT], value: EMetricTypes.SINGLE_EVENT },
  { label: metricTypeMapping[EMetricTypes.RATIO_METRIC], value: EMetricTypes.RATIO_METRIC },
];

export const COLORS = [
  '#A2E2E6',
  '#C8E6A2',
  '#94A5FE',
  '#7EA0A7',
  '#FEB085',
  '#C7C6F8',
  '#FEAAAA',
  '#FE9E69',
  '#E59CB9',
  '#CD8086',
];

export const APP_TOTAL_USER_EVENTS = 'app_total_user_events';

export const EXPLORER_DIMENSION_KEYS = {
  USER_ID: 'user_id',
  CLIENT_ID: 'client_id',
  DEVICE_NAME: 'device_name',
  APPLICATION_VERSION: 'application_version',
  APP_ID: 'app_id',
  DA_MODEL: 'da_model',
  BROWSER_NAME: 'browser_name',
  GEO_CITY: 'geo_city',
  GEO_ZIPCODE: 'geo_zipcode',
  GEO_REGION: 'geo_region',
  GEO_COUNTRY: 'geo_country',
  APP_PLATFORM: 'app_platform',
  IP_ISP: 'ip_isp',
  NET_SPEED: 'net_speed',
  IP_V4: 'ip_v4',
  IP_V6: 'ip_v6',
  MAX_EVENT_TIME: 'max_event_time',
  EVENT_TAGS: 'event_tags',
  CUSTOM_TAGS: 'custom_tags',
  EVENT_TIME: 'event_time',
  SESSION_ID: 'session_id',
  IN_SESSION: 'in_session',
  EVENT_NAME: 'event_name',
  EVENT_ID: 'event_id',
  REFR_URLHOST: 'refr_urlhost',
  PAGE_URLHOST: 'page_urlhost',
  PAGE_URLPATH: 'page_urlpath',
  PAGE_URLQUERY: 'page_urlquery',
  REFERRER: 'referrer',
  TITLE: 'title',
  PAGE_URL: 'page_url',
};
export const EXPLORER_DIMENSION_NAMES = {
  USER_ID: 'User ID',
  DEVICE_NAME: 'Device Name',
  APPLICATION_VERSION: 'App Version',
  APP_ID: 'App Name',
  DA_MODEL: 'Device Model',
  BROWSER_NAME: 'Browser Name',
  GEO_CITY: 'City',
  GEO_REGION: 'Region',
  GEO_COUNTRY: 'Country',
  GEO_ZIPCODE: 'Zipcode',
  APP_PLATFORM: 'Platform',
  IP_ISP: 'ISP',
  NET_SPEED: 'Connections',
  IP_V4: 'IP Address',
  IP_V6: 'IP Address',
  MAX_EVENT_TIME: 'Last Seen',
  EVENT_TAGS: 'Event Tags',
  CUSTOM_TAGS: 'Custom Tags',
  EVENT_TIME: 'Event Time',
  SESSION_ID: 'Session Id',
  IN_SESSION: 'In Session',
};

export const KeyMap = {
  // conviva_button_click: `Button Text`,
  targetUrl: `Target Url`,
  conviva_screen_view: `Screen Title`,
  // conviva_page_view: `Page Title`,
  conviva_link_click: `Link Target`,
  responseStatusCode: 'Network Request Response Code',
  duration: 'Duration',
  page_title: `Page Title`,
  elementText: `Button Text`,
};
